import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import demoAvatar from 'src/assets/demo/avatar.png';
import { PROFILE_ROUTE } from 'src/constants/routes';

import css from './Avatar.module.scss';

type Props = {
  avatarUrl?: string;
  size?: 'small' | 'large';
  className?: string;
  linked?: boolean;
};

export default function Avatar({
  avatarUrl = demoAvatar,
  size = 'small',
  className,
  linked = true,
}: Props) {
  const image = <img className={css.avatar} src={avatarUrl} alt="" width={44} height={44} />;

  if (!linked) {
    return <div className={cn(css.userLink, css[size], className)}>{image}</div>;
  }

  return (
    <Link to={PROFILE_ROUTE} className={cn(css.userLink, css[size], className)}>
      {image}
    </Link>
  );
}
